<template>
  <div class="container-fluid">
    <div class="row">
      <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-white sidebar collapse d-sm-none d-md-block d-lg-block">
        <a class="brand-none navbar-brand col-md-3 col-lg-2 me-0 px-3" href="#">
          <img class="img-fluid" :src="require('@/assets/img/brand.png')" style="width:80%;">
        </a>
        <div class="position-sticky" align="left">
          <ul class="m-p-sidebar nav flex-column mb-auto">
            <li class="nav-item ">
              <router-link to="/dashboard/manager/" class="btn btn-toggle-2 align-items-center rounded  nav-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgba(13,62,103,1)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-home" aria-hidden="true">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                  <polyline points="9 22 9 12 15 12 15 22"></polyline>
                </svg>Home
              </router-link>
            </li>
            <li class="nav-item ">
              <a class="btn btn-toggle align-items-center rounded collapsed nav-link" data-bs-toggle="collapse" data-bs-target="#activity-collapse" aria-expanded="false" aria-current="page" href="#">
                <i class="fas fa-chart-line margin-r"></i> Activity </a>
              <div class="collapse" id="activity-collapse" style="">
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                  <li>
                    <router-link to="/dashboard/manager/app" class="dropdown-item rounded">Apps</router-link>
                  </li>
                  <li>
                    <router-link to="/dashboard/manager/screenshot"  class="dropdown-item rounded">Screenshot</router-link>
                  </li>
                  <li>
                    <router-link to="/dashboard/manager/url" class="dropdown-item rounded">URLs</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item">
              <a class="btn btn-toggle align-items-center nav-link rounded collapsed" data-bs-toggle="collapse" data-bs-target="#project-collapse" aria-expanded="false">
                <i class="fas fa-project-diagram margin-r"></i> Projects </a>
              <div class="collapse" id="project-collapse" style="">
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 ">
                  <li>
                    <router-link to="/dashboard/manager/project" class="dropdown-item rounded">Project</router-link>
                  </li>
                  <li>
                    <router-link to="/dashboard/manager/todo" class="dropdown-item rounded">To-do</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="nav-item">
              <router-link to="/dashboard/manager/report" class="btn btn-toggle-2 align-items-center rounded  nav-link">
                <i class="fas fa-file-alt margin-r"></i> Reports
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/dashboard/manager/timesheet" class="btn btn-toggle-2 align-items-center rounded  nav-link">
                <i class="fas fa-stopwatch margin-r"></i> Timesheets
              </router-link>
            </li>
            <!--<li class="nav-item">
              <a class="btn btn-toggle align-items-center nav-link rounded collapsed" data-bs-toggle="collapse" data-bs-target="#user-collapse" aria-expanded="false">
                <i class="fas fa-user margin-r"></i> Users </a>
              <div class="collapse" id="user-collapse">
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 ">
                  <li>
                    <router-link to="/dashboard/team/member" class="dropdown-item rounded">Members</router-link>
                  </li>
                </ul>
              </div>
            </li>-->
            <!--<li class="nav-item ">
              <a class="btn btn-toggle align-items-center nav-link rounded collapsed" data-bs-toggle="collapse" data-bs-target="#settings" aria-expanded="false">
                <i class="fas fa-cogs margin-r"></i> Settings </a>
              <div class="collapse" id="settings">
                <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 ">
                  <li>
                    <router-link to="/dashboard/team/subscription" class="dropdown-item rounded">Plan info</router-link>
                  </li>
                  <li>
                    <router-link to="/dashboard/team/plan" class="dropdown-item rounded">Upgrade Plan</router-link>
                  </li>
                  <li>
                    <router-link to="/dashboard/team/payroll" class="dropdown-item rounded">Payroll</router-link>
                  </li>
                </ul>
              </div>
            </li>-->
          </ul>
          <hr>
          <div class="dropdown ms-1">
            <a href="#" class="d-flex align-items-center nav-link text-decoration-none dropdown-toggle" id="dropdownUser2" data-bs-toggle="dropdown" aria-expanded="false">
              <div class='icon-container'>
                <img :src="profileInfo.picture" alt="" width="38" height="38" class="img-avatar">
                <div class='status-circle'></div>
              </div>
              <div class="user-side" align="center">
                <span>
                  {{profileInfo.names}}
                </span>                
              </div>              
            </a>
            <ul class="dropdown-menu text-small shadow" aria-labelledby="dropdownUser2">
              <!--<li>
                <router-link to="/dashboard/manager/project" class="dropdown-item">New project...</router-link>
              </li>-->             
              <li>
                <router-link to="/dashboard/manager/setting/profile" class="dropdown-item">Profile</router-link>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li>
                <router-link to="#" class="dropdown-item" v-on:click="Logout">Sign out</router-link>
              </li>
            </ul>
             <select id="select-online" class="select-css" @change="SelectChanged" v-bind:style="{ backgroundColor: this.UpdateOnlinePost.color}">
              <option  value="1">Online</option>
              <option value="2">Away</option>
              <option value="4">Busy</option>
            </select>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>
<script>
import Api from '@/services/Request'; 
import $ from 'jquery'; 

  export default
  {
    name: 'SideMenu',
    data: () => (
    {
      profileInfo: 
      {
        names:"",
        picture:""
      },
      UpdateOnlinePost: 
      {
        status: "",
        inserted: "",
        color: ""
      } 
    }),
    computed: 
    {
      Role () 
      {
        return (this.$getRole())
      }
    },
    methods: 
    {
      Logout() 
      {
        Api.get("/login/logout").then((result) => 
        {
          if(result.data.status == "true")
          {
            this.$store.commit("setOnline","");
            this.$store.commit("setAuthentication", false);
            this.$store.commit("setTypeUser", "");
            this.$store.commit("setToken", "");
            localStorage.clear();
            this.$router.push({ name: "Home" });
          }
        })
      },
      UpdateOnline() 
      {
      
        Api.post("connection/get").then((result) => 
          {
            if(result.data.status == "true")
            {
              this.UpdateOnlinePost.color =  result.data.list.color
              this.$store.commit("setOnline", result.data.list.id)  
              $('#select-online option[value="'+result.data.list.id+'"]').attr("selected","selected");
                
            }
              
          })
      
      },
      SelectChanged(e) 
      {
        this.UpdateOnlinePost.status = e.target.value

        Api.post("connection/get").then((result) => 
        {
          if(result.data.status == "true")
          {
           
            if(this.UpdateOnlinePost.status != result.data.list.id)
            {

                Api.post("connection/status", this.UpdateOnlinePost).then((result) => 
                {
                  if(result.data.status == "true")
                  {
                      Api.post("connection/get").then((result) => 
                     {
                        if(result.data.status == "true")
                        {
                          this.$store.commit("setOnline", result.data.list.id)
                          this.UpdateOnlinePost.color =  result.data.list.color
                        }
                          
                     })
                    
                  }
                })

            }
            
          }
        })
        
      },
      Profile ()
      {
        this.profileInfo.names =  localStorage.getItem('names')
        this.profileInfo.picture = localStorage.getItem('picture')
      }
    },
    mounted()
    {
      this.Profile()
      this.UpdateOnline()
    }
  }
</script>

<style>
.select-css 
{
  background-color: #fff;
  border: thin solid #fff;
  border-radius: 0 100px 100px 0;
  display: inline-block;
  color:#0d3e67;
  line-height: 1.5em;
  padding: 0.5em 3.5em 0.5em 1em;

  margin: 0;      
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}
option 
{
  background-color: #fff;
}

</style>
